import React, { useState, useEffect } from 'react';

const Setup = ({ onSave, onCancel }) => {
   const [config, setConfig] = useState({
       baseIP: '192.168.1.14',
       ports: {
           login: 5015,
           passport: 5006,
           treasury: 5004,
           reports: 5010,
           whatsapp: 5016,
           flight: 5011,
           companyTransactions: 5018,
           banks: 5001,
           clients: 5005,
           delegates: 5003,
           companyManagement: 5007,
           delegatesManagement: 5008,
           professions: 5009,
           visaManagement: 5012,
           visaReports: 5013,
           userManagement: 5014,
           dataImport: 5020,  // المنفذ الجديد

 humanResources: 5050 
       }
   });

   const [autoDetectedIP, setAutoDetectedIP] = useState('');
   const [isDetecting, setIsDetecting] = useState(false);
   const [customDefaultIP, setCustomDefaultIP] = useState('192.168.1.14');
   const [testingConnection, setTestingConnection] = useState(false);
   const [connectionStatus, setConnectionStatus] = useState('');
// في Setup.js، أضف هذه الـ states
const [autoMode, setAutoMode] = useState(true); // وضع تلقائي افتراضي
const [manualIP, setManualIP] = useState(''); // IP يدوي مؤقت
const [lastAutoDetected, setLastAutoDetected] = useState('');


// في Setup.js، أضف هذه الـ states في البداية
const [showModeSelector, setShowModeSelector] = useState(false);

useEffect(() => {
    // تحميل الوضع المحفوظ
    const savedMode = localStorage.getItem('autoMode');
    if (savedMode) {
        try {
            setAutoMode(JSON.parse(savedMode));
        } catch (error) {
            console.error('خطأ في تحميل الوضع المحفوظ:', error);
        }
    }

    // تحميل الافتراضي المخصص
    const savedDefault = localStorage.getItem('customDefaultIP');
    if (savedDefault) {
        setCustomDefaultIP(savedDefault);
    }

    // تحميل التكوين المحفوظ إن وجد
    const saved = localStorage.getItem('systemConfig');
    if (saved) {
        try {
            const parsedConfig = JSON.parse(saved);
            setConfig(parsedConfig);
        } catch (error) {
            console.error('خطأ في تحميل التكوين المحفوظ:', error);
        }
    }
    
    // **فقط اكتشف IP إذا كان الوضع تلقائي**
    const savedModeData = localStorage.getItem('autoMode');
    const isAutoMode = savedModeData ? JSON.parse(savedModeData) : true;
    
    if (isAutoMode) {
        detectLocalIP();
    }
}, []);



const manualDetectIP = () => {
    setIsDetecting(true);
    detectLocalIP();
};


// في Setup.js، عدل detectLocalIP لتستخدم IP تلقائياً
const detectLocalIP = async () => {
    // إذا كان الوضع يدوي ولم يطلب المستخدم الاكتشاف، لا تعمل شيء
    if (!autoMode && !isDetecting) {
        return;
    }
    
    setIsDetecting(true);
    
    try {
        // جرب الحصول على IP من السيرفر
        const tryGetFromServer = async (baseIP, port) => {
            try {
                const response = await fetch(`http://${baseIP}:${port}/api/network/local-ip`, {
                    method: 'GET',
                    timeout: 3000
                });
                
                if (response.ok) {
                    const data = await response.json();
                    if (data.success && data.primary) {
                        return data.primary;
                    }
                }
            } catch (error) {
                console.log(`Failed to get IP from ${baseIP}:${port}`);
            }
            return null;
        };

        const commonIPs = ['127.0.0.1', 'localhost', '192.168.1.14'];
        const ports = [5015, 5000];

        let detectedIP = null;

        for (const ip of commonIPs) {
            for (const port of ports) {
                const result = await tryGetFromServer(ip, port);
                if (result) {
                    detectedIP = result;
                    break;
                }
            }
            if (detectedIP) break;
        }

        if (detectedIP) {
            setAutoDetectedIP(detectedIP);
            
            // **فقط طبق IP إذا كان الوضع تلقائي**
            if (autoMode) {
                setConfig(prev => ({ ...prev, baseIP: detectedIP }));
                
                setTimeout(() => {
                    autoSaveConfig(detectedIP);
                }, 1000);
                
                console.log('IP detected and applied automatically:', detectedIP);
            } else {
                console.log('IP detected but not applied (manual mode):', detectedIP);
            }
        } else {
            console.log('Could not detect IP automatically');
        }

    } catch (error) {
        console.error('Error detecting IP:', error);
    } finally {
        setIsDetecting(false);
    }
};

// دالة للحفظ التلقائي
const autoSaveConfig = (detectedIP) => {
    const newConfig = {
        ...config,
        baseIP: detectedIP
    };
    
    // حفظ في localStorage
    localStorage.setItem('systemConfig', JSON.stringify(newConfig));
    
    // إنشاء URLs
    const configURLs = generateConfigObject(newConfig);
    localStorage.setItem('systemURLs', JSON.stringify(configURLs));
    
    // حفظ في التاريخ
    saveIPToHistory(detectedIP);
    
    console.log('Configuration saved automatically');
};

// دالة WebRTC كحل احتياطي
const detectViaWebRTC = () => {
    return new Promise((resolve) => {
        const pc = new RTCPeerConnection({
            iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]
        });
        
        pc.createDataChannel('test');
        
        let foundIP = false;
        
        pc.onicecandidate = (event) => {
            if (event.candidate && !foundIP) {
                const candidate = event.candidate.candidate;
                const match = /([0-9]{1,3}(\.[0-9]{1,3}){3})/.exec(candidate);
                
                if (match && match[1] && 
                    !match[1].startsWith('127.') && 
                    !match[1].startsWith('169.254.')) {
                    foundIP = true;
                    resolve(match[1]);
                    pc.close();
                }
            }
        };
        
        pc.createOffer().then(offer => pc.setLocalDescription(offer));
        
        setTimeout(() => {
            if (!foundIP) {
                pc.close();
                resolve(null);
            }
        }, 5000);
    });
};


const testNetworkAPI = async () => {
    try {
        const response = await fetch('/api/network/local-ip');
        const data = await response.json();
        
        if (data.success) {
            alert(`تم العثور على IP: ${data.primary}\nاسم الجهاز: ${data.hostname}`);
            setAutoDetectedIP(data.primary);
        } else {
            alert('فشل في الحصول على IP من السيرفر');
        }
    } catch (error) {
        alert('خطأ في الاتصال بالسيرفر');
    }
};


   const useAutoDetected = () => {
       if (autoDetectedIP) {
           setConfig(prev => ({ ...prev, baseIP: autoDetectedIP }));
       }
   };

   const saveAsDefault = () => {
       localStorage.setItem('customDefaultIP', config.baseIP);
       setCustomDefaultIP(config.baseIP);
       alert(`تم حفظ ${config.baseIP} كعنوان افتراضي`);
   };

   const useCustomDefault = () => {
       const saved = localStorage.getItem('customDefaultIP');
       if (saved) {
           setConfig(prev => ({ ...prev, baseIP: saved }));
       } else {
           // إذا لم يوجد، استخدم الافتراضي الأصلي
           setConfig(prev => ({ ...prev, baseIP: '192.168.1.14' }));
       }
   };

   const testConnection = async () => {
       setTestingConnection(true);
       setConnectionStatus('جاري الاختبار...');
       
       try {
           // اختبار الاتصال بالسيرفر
           const testURL = `http://${config.baseIP}:${config.ports.login}/test`;
           
           const controller = new AbortController();
           const timeoutId = setTimeout(() => controller.abort(), 5000);
           
           const response = await fetch(testURL, {
               method: 'GET',
               signal: controller.signal,
               mode: 'cors'
           });
           
           clearTimeout(timeoutId);
           
           if (response.ok) {
               setConnectionStatus('✅ الاتصال ناجح! يمكن الوصول للسيرفر');
           } else {
               setConnectionStatus('❌ السيرفر غير متاح على هذا العنوان');
           }
           
       } catch (error) {
           if (error.name === 'AbortError') {
               setConnectionStatus('⏱️ انتهت مهلة الاتصال - تأكد من العنوان والشبكة');
           } else {
               setConnectionStatus('❌ فشل الاتصال - تأكد من تشغيل السيرفر');
           }
       } finally {
           setTestingConnection(false);
       }
   };

   const saveIPToHistory = (ip) => {
       try {
           const previousIPs = JSON.parse(localStorage.getItem('previousIPs') || '[]');
           
           // إضافة IP الجديد إذا لم يكن موجوداً
           if (!previousIPs.includes(ip)) {
               previousIPs.push(ip);
               
               // احتفظ بآخر 5 عناوين فقط
               if (previousIPs.length > 5) {
                   previousIPs.shift();
               }
               
               localStorage.setItem('previousIPs', JSON.stringify(previousIPs));
           }
       } catch (error) {
           console.error('خطأ في حفظ IP:', error);
       }
   };

const handleSave = () => {
    const ipToSave = config.baseIP;
    
    console.log('Saving IP:', ipToSave, 'Mode:', autoMode ? 'Auto' : 'Manual');
    
    // حفظ IP في التاريخ
    saveIPToHistory(ipToSave);
    
    // حفظ التكوين
    localStorage.setItem('systemConfig', JSON.stringify(config));
    
    // حفظ وضع التكوين
    localStorage.setItem('autoMode', JSON.stringify(autoMode));
    
    // إنشاء config object جديد
    const newConfig = generateConfigObject(config);
    localStorage.setItem('systemURLs', JSON.stringify(newConfig));
    
    console.log(`Configuration saved - Mode: ${autoMode ? 'Auto' : 'Manual'}, IP: ${ipToSave}`);
    
    onSave(config);
};

const generateConfigObject = (configData) => {
    return {
        API_BASE_URL: `http://${configData.baseIP}:${configData.ports.login}`,
        PASSPORT_API_URL: `http://${configData.baseIP}:${configData.ports.passport}`,
        TREASURY_API_URL: `http://${configData.baseIP}:${configData.ports.treasury}`,
        REPORTS_API_URL: `http://${configData.baseIP}:${configData.ports.reports}`,
        WHATSAPP_API_URL: `http://${configData.baseIP}:${configData.ports.whatsapp}`,
        WHATSAPP_WS_URL: `${configData.baseIP}:${configData.ports.whatsapp}`,
        FLIGHT_API_URL: `http://${configData.baseIP}:${configData.ports.flight}`,
        COMPANY_TRANSACTIONS_API_URL: `http://${configData.baseIP}:${configData.ports.companyTransactions}`,
        BANKS_API_URL: `http://${configData.baseIP}:${configData.ports.banks}`,
        CLIENTS_API_URL: `http://${configData.baseIP}:${configData.ports.clients}`,
        DELEGATES_API_URL: `http://${configData.baseIP}:${configData.ports.delegates}`,
        COMPANY_MANAGEMENT_API_URL: `http://${configData.baseIP}:${configData.ports.companyManagement}`,
        DELEGATES_MANAGEMENT_API_URL: `http://${configData.baseIP}:${configData.ports.delegatesManagement}`,
        PROFESSIONS_API_URL: `http://${configData.baseIP}:${configData.ports.professions}`,
        VISA_MANAGEMENT_API_URL: `http://${configData.baseIP}:${configData.ports.visaManagement}`,
        VISA_REPORTS_API_URL: `http://${configData.baseIP}:${configData.ports.visaReports}`,
        USER_MANAGEMENT_API_URL: `http://${configData.baseIP}:${configData.ports.userManagement}`,
        HUMAN_RESOURCES_API_URL: `http://${configData.baseIP}:${configData.ports.humanResources}`,
        DATA_IMPORT_API_URL: `http://${configData.baseIP}:${configData.ports.dataImport}`  // الجديد
    };
};

   const resetToDefaults = () => {
       setConfig({
           baseIP: '192.168.1.14',
ports: {
    login: 5015,
    passport: 5006,
    treasury: 5004,
    reports: 5010,
    whatsapp: 5016,
    flight: 5011,
    companyTransactions: 5018,
    banks: 5001,
    clients: 5005,
    delegates: 5003,
    companyManagement: 5007,
    delegatesManagement: 5008,
    professions: 5009,
    visaManagement: 5012,
    visaReports: 5013,
    userManagement: 5014,
    humanResources: 5050  // موجود ✅
}
       });
   };

   return (
       <div className="min-h-screen bg-gray-100 p-4">
           <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-lg p-8">
               <div className="text-center mb-8">
                   <h1 className="text-3xl font-bold text-gray-800 mb-2">
                       إعداد نظام إدارة الجوازات
                   </h1>
                   <p className="text-gray-600">
                       قم بتكوين عناوين الشبكة للوصول إلى خدمات النظام
                   </p>
               </div>



{/* زر التحكم في الوضع */}
<div className="mb-6 text-center">
    <button 
        onClick={() => setShowModeSelector(!showModeSelector)}
        className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors text-sm"
    >
        ⚙️ خيارات متقدمة
    </button>
</div>

{showModeSelector && (
    <div className="mb-8 p-6 bg-yellow-50 rounded-lg border border-yellow-200">
        <h3 className="text-lg font-semibold mb-4 text-yellow-800">وضع التكوين</h3>
        <div className="space-y-3">
            <label className="flex items-center gap-3 cursor-pointer">
                <input
                    type="radio"
                    name="configMode"
                    checked={autoMode}
                    onChange={() => setAutoMode(true)}
                    className="text-blue-500"
                />
                <div>
                    <span className="font-medium text-green-700">تلقائي (موصى به)</span>
                    <div className="text-sm text-gray-600">يكتشف ويحفظ IP تلقائياً</div>
                </div>
            </label>
            
            <label className="flex items-center gap-3 cursor-pointer">
                <input
                    type="radio"
                    name="configMode"
                    checked={!autoMode}
                    onChange={() => setAutoMode(false)}
                    className="text-blue-500"
                />
                <div>
                    <span className="font-medium text-orange-700">يدوي</span>
                    <div className="text-sm text-gray-600">تحكم كامل في اختيار IP</div>
                </div>
            </label>
        </div>
        
        {!autoMode && (
            <div className="mt-4 p-3 bg-orange-50 rounded border border-orange-200">
                <p className="text-sm text-orange-700">
                    <strong>ملاحظة:</strong> في الوضع اليدوي، لن يتم تطبيق IP المكتشف تلقائياً. 
                    ستحتاج لاختيار IP بنفسك.
                </p>
            </div>
        )}
    </div>
)}





               {/* اكتشاف IP تلقائي */}
               {/* اكتشاف IP تلقائي */}
<div className="mb-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
    <h3 className="text-lg font-semibold mb-4 text-blue-800">
        الكشف التلقائي عن عنوان IP
        {autoMode && <span className="text-sm bg-green-100 text-green-700 px-2 py-1 rounded ml-2">نشط</span>}
        {!autoMode && <span className="text-sm bg-orange-100 text-orange-700 px-2 py-1 rounded ml-2">متوقف</span>}
    </h3>
    
    {isDetecting ? (
        <div className="flex items-center gap-3">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
            <span className="text-blue-700">جاري البحث عن عنوان IP...</span>
        </div>
    ) : autoDetectedIP ? (
        <div className="space-y-3">
            <div className="flex items-center gap-4">
                <span className="text-green-700 font-medium">✅ تم اكتشاف: {autoDetectedIP}</span>
                {autoMode && <span className="text-green-600 text-sm bg-green-100 px-2 py-1 rounded">تم التطبيق تلقائياً</span>}
                {!autoMode && <span className="text-orange-600 text-sm bg-orange-100 px-2 py-1 rounded">لم يتم التطبيق</span>}
            </div>
            
            <div className="flex gap-2">
    {!autoMode && (
        <button 
            onClick={() => {
                setConfig(prev => ({ ...prev, baseIP: autoDetectedIP }));
                alert('تم تطبيق IP المكتشف!');
            }}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
        >
            ✓ استخدام IP المكتشف
        </button>
    )}
    
    <button 
        onClick={manualDetectIP}
        className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
    >
        🔄 إعادة البحث
    </button>
    
    <button 
        onClick={testNetworkAPI}
        className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600 transition-colors"
    >
        🧪 اختبار API
    </button>
</div>
        </div>
    ) : (
        <div className="space-y-3">
            <span className="text-gray-600">❌ لم يتم العثور على عنوان IP تلقائياً</span>
            <div className="flex gap-2">
                <button 
                    onClick={detectLocalIP}
                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
                >
                    🔍 محاولة مرة أخرى
                </button>
                
                <button 
                    onClick={testNetworkAPI}
                    className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600 transition-colors"
                >
                    🧪 اختبار API
                </button>
            </div>
        </div>
    )}
</div>

               {/* إعداد IP يدوي */}
               <div className="mb-8">
                   <label className="block text-lg font-semibold mb-3 text-gray-700">
                       عنوان IP للسيرفر:
                   </label>
                   <div className="flex gap-2">
                       <input
                           type="text"
                           value={config.baseIP}
                           onChange={(e) => setConfig(prev => ({ ...prev, baseIP: e.target.value }))}
                           className="flex-1 p-3 border border-gray-300 rounded-lg text-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                           placeholder="مثال: 192.168.1.14"
                       />
                       <button 
                           onClick={useCustomDefault}
                           className="bg-blue-500 text-white px-4 py-3 rounded-lg hover:bg-blue-600 transition-colors whitespace-nowrap"
                           title={`الافتراضي: ${customDefaultIP}`}
                       >
                           افتراضي
                       </button>
                       <button 
                           onClick={saveAsDefault}
                           className="bg-green-500 text-white px-4 py-3 rounded-lg hover:bg-green-600 transition-colors whitespace-nowrap"
                           title="حفظ العنوان الحالي كافتراضي"
                       >
                           حفظ كافتراضي
                       </button>
                       <button 
                           onClick={testConnection}
                           disabled={testingConnection}
                           className="bg-orange-500 text-white px-4 py-3 rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap disabled:bg-orange-300"
                       >
                           {testingConnection ? 'اختبار...' : 'اختبار الاتصال'}
                       </button>
                   </div>
                   <p className="text-gray-600 mt-2 text-sm">
                       أدخل عنوان IP الخاص بالجهاز الذي يحتوي على خدمات النظام
                   </p>
                   {customDefaultIP !== '192.168.1.14' && (
                       <p className="text-blue-600 mt-1 text-sm">
                           العنوان الافتراضي المحفوظ: {customDefaultIP}
                       </p>
                   )}
                   
                   {connectionStatus && (
                       <div className={`mt-2 p-2 rounded ${
                           connectionStatus.includes('✅') ? 'bg-green-100 text-green-700' : 
                           connectionStatus.includes('⏱️') ? 'bg-yellow-100 text-yellow-700' : 
                           'bg-red-100 text-red-700'
                       }`}>
                           {connectionStatus}
                       </div>
                   )}
               </div>

               {/* عرض المنافذ */}
               <div className="mb-8">
                   <h3 className="text-lg font-semibold mb-4 text-gray-700">المنافذ المستخدمة:</h3>
                   <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                       {Object.entries(config.ports).map(([service, port]) => (
                           <div key={service} className="p-3 bg-gray-50 rounded-lg border">
                               <div className="font-medium text-gray-700 text-sm mb-1">
                                   {service === 'login' ? 'تسجيل الدخول' :
                                    service === 'passport' ? 'الجوازات' :
                                    service === 'treasury' ? 'الخزينة' :
                                    service === 'reports' ? 'التقارير' :
                                    service === 'whatsapp' ? 'واتساب' :
                                    service === 'flight' ? 'الطيران' :
                                    service === 'companyTransactions' ? 'معاملات الشركة' :
                                    service === 'banks' ? 'البنوك' :
                                    service === 'clients' ? 'العملاء' :
                                    service === 'delegates' ? 'المناديب' :
                                    service === 'companyManagement' ? 'إدارة الشركات' :
                                    service === 'delegatesManagement' ? 'إدارة المناديب' :
                                    service === 'professions' ? 'المهن' :
                                    service === 'visaManagement' ? 'إدارة التأشيرات' :
                                    service === 'visaReports' ? 'تقارير التأشيرات' :
                                    service === 'humanResources' ? 'الموارد البشرية' :
                                    service === 'dataImport' ? 'إدارة البيانات' :

                                    service === 'userManagement' ? 'إدارة المستخدمين' : service}
                               </div>
                               <div className="text-blue-600 font-mono">:{port}</div>
                           </div>
                       ))}
                   </div>
               </div>

               {/* معاينة URLs */}
               <div className="mb-8">
                   <h3 className="text-lg font-semibold mb-4 text-gray-700">معاينة العناوين المُولدة:</h3>
                   <div className="bg-gray-50 p-4 rounded-lg border max-h-40 overflow-y-auto">
                       <div className="text-sm space-y-1">
                           <div className="text-blue-600 font-mono">تسجيل الدخول: http://{config.baseIP}:{config.ports.login}</div>
                           <div className="text-blue-600 font-mono">الجوازات: http://{config.baseIP}:{config.ports.passport}</div>
                           <div className="text-blue-600 font-mono">الخزينة: http://{config.baseIP}:{config.ports.treasury}</div>
                           <div className="text-blue-600 font-mono">التقارير: http://{config.baseIP}:{config.ports.reports}</div>
                           <div className="text-gray-500">... والباقي</div>
                       </div>
                   </div>
               </div>

               {/* أزرار التحكم */}
               <div className="flex gap-4 justify-center">
                   <button 
                       onClick={handleSave}
                       className="bg-green-500 text-white px-8 py-3 rounded-lg text-lg font-medium hover:bg-green-600 transition-colors"
                   >
                       حفظ الإعدادات
                   </button>
                   {onCancel && (
                       <button 
                           onClick={onCancel}
                           className="bg-gray-500 text-white px-8 py-3 rounded-lg text-lg font-medium hover:bg-gray-600 transition-colors"
                       >
                           إلغاء
                       </button>
                   )}
               </div>
           </div>
       </div>
   );
};

export default Setup;